export enum InviteStatusEnum {
  Active = 'active',
  Invited = 'invited',
  Suspended = 'suspended',
}
